import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../react-oe/oe-interface-adapter';
import {OEPortal} from '../../lib/components/oe-window';
import OEResizeObserver from '../../lib/components/oe-resize-observer';

export const OECoreUserNotificationStyle = {
    std:                        0,
    alert:                      1
};

export const OEUserNotificationStyle = {
    alert:                      'alert'
};

OEUserNotificationStyle.fromCore = style => {
    switch(style)   {
        case OECoreUserNotificationStyle.alert: return OEUserNotificationStyle.alert;
    }
    return;
};

//
export default class OEUserNotificationView extends React.PureComponent { 

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.idCounter = 0;

        this.notifications = [];

        this.state = {
            notifications:  []
        };

        this.updateLanguage = this.updateLanguage.bind(this);
        this.onShowUserNotification = this.onShowUserNotification.bind(this);
    }

    componentWillReceiveProps(nextProps) {
    }

    componentWillUnmount()    {
        this.umount = true;

        this.notifications.forEach(notification => {
            if(!notification.timeout) return;
            clearTimeout(notification.timeout);
            notification.timeout = null;
        });
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.showUserNotification, this.onShowUserNotification);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.showUserNotification, this.onShowUserNotification);
    }

    getNotification(id) {
        return this.notifications.find(notification => notification.id === id);
    }

    pushMessage(message, style)    {
        let notification = {message: message};
        notification.style = style;
        return this.push(notification);
    }

    pushMessageId(messageId, message, style)    {
        let notification = {messageId: messageId}
        if(typeof(message) === 'string')    notification.message = message;
        notification.style = style;
        return this.push(notification);
    }

    push(notification)  {
        if(typeof(notification) === 'string')   {
            return this.push({message: notification});
        }

        //
        if(typeof(notification) !== 'object' || !notification)  return;

        //
        if(typeof(notification.message) !== 'string')   notification.message = undefined;
        if(typeof(notification.messageId) !== 'string') notification.messageId = undefined;

        //
        if(!notification.message && !notification.messageId)  return;

        //
        notification = {...notification};

        //
        if(typeof(notification.style) === 'number') {
            notification.style = OEUserNotificationStyle.fromCore(notification.style);
        } else if(typeof(notification.style) !== 'string') {
            notification.style = undefined;
        }

        //
        let animate = this.props.animate && this.props.animationDuration > 0;
        notification.animationDuration = animate ? this.props.animationDuration : 0;

        //
        notification.elementStyle = {};
        let animDuration = this.props.animationDuration;
        notification.elementStyle.transition = animate ? `height ${animDuration}ms linear, margin-top ${animDuration}ms linear, opacity ${animDuration}ms linear` : '';
   
        //
        let id = this.idCounter++;
        notification.id = id;

        //
        notification.message_ = notification.message;
        if(notification.messageId && this.oe.isReady())  {
            notification.message = this.oe.sharedInterface.getLocalizedStringEnc(notification.messageId);
        }

        //
        let duration = typeof(notification.duration) === 'number' && notification.duration >= 0 ? notification.duration : this.props.notificationStdDuration;
        notification.duration = duration;
        
        notification.onResize = (sender, size) => {
            if(this.umount)   return;

            if(notification.show)   {
                this.onNotificationResize(notification.id, size);
            } else {
                this.onNotificationShow(notification.id, size);
            }
        };

        //
        this.notifications.push(notification);

        //
        if(this.props.maxNotifications > 0 && this.props.maxNotifications < this.notifications.length)  {
            let remove = this.notifications.length - this.props.maxNotifications;

            let ids = [];
            for(let i = 0; i < remove; ++i) ids.push(this.notifications[i].id);

            ids.forEach(id => { this.onNotificationFinished(id); })
        }
        
        //
        this.updateNotificationState();

        //
        return notification.id;
    }

    onNotificationShow(id, size)  {
        let notification = this.getNotification(id);
        if(!notification)   return;

        notification.elementStyle.width = size.w;
        notification.elementStyle.height = size.h;
        
        notification.show = true;

        notification.timeout = setTimeout(() => {
            notification.timeout = null;
            if(this.umount) return;
            this.onNotificationFinished(notification.id);
        }, notification.duration + notification.animationDuration);

        //
        this.updateNotificationState();
    }

    onNotificationResize(id, size)  {
        let notification = this.getNotification(id);
        if(!notification)   return;

        notification.elementStyle.width = size.w;
        notification.elementStyle.height = size.h;

        //
        this.updateNotificationState();
    }

    onNotificationFinished(id)  {

        if(!(this.props.animate && this.props.animationDuration > 0)) {
            this.removeNotification(id);
            return;
        }

        //
        let notification = this.getNotification(id);
        if(!notification)   return;

        notification.elementStyle.width = undefined;
        notification.elementStyle.height = undefined;

        notification.finished = true;

        notification.onResize = undefined;

        notification.timeout = setTimeout(() => {
            notification.timeout = null;
            if(this.umount) return;
            this.removeNotification(notification.id);
        }, notification.animationDuration);

        //
        this.updateNotificationState();
    }

    removeNotification(id)  {
        let index = this.notifications.findIndex(notification => notification.id === id);
        if(index < 0)   return;
        
        //
        let notification = this.notifications[index];
        if(notification.timeout)    {
            clearTimeout(notification.timeout);
            notification.timeout = null;
        }

        //
        this.notifications.splice(index, 1);

        //
        this.updateNotificationState();
    }

    updateNotificationState()   {
        this.setState({notifications: clone(this.notifications)});
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;

        let change = false;

        this.notifications.forEach(notification => {
            if(!notification.messageId) return;

            let message = si.getLocalizedStringEnc(notification.messageId);
            if(message === notification.message)    return;

            notification.message = message;
            change = true;
        });

        if(!change)  return;

        //
        this.updateNotificationState();
    }

    onShowUserNotification(message, userInfo)    {
        this.pushMessage(userInfo.text, userInfo.style);
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    render() {

        let notifications = this.state.notifications.filter(notification => !!notification.message).map((notification, i) => {
            let className = 'user-notification';
            if(notification.show && !notification.finished) className += ' user-notification-show'
            if(notification.style)  className += ' user-notification-style-' + notification.style;

            return (
                <div key={notification.id} className={className} style={notification.elementStyle}>
                    <div className="user-notification-content">
                        <OEResizeObserver onResize={notification.onResize}/>
                        <span>{notification.message}</span>
                    </div>
                </div>
            );
        });

        return(
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <OEPortal>
                    <div className={'user-notification-view no-blur ' + this.props.className}>
                        {notifications}
                    </div>
                </OEPortal>

            </React.Fragment>
        );
    }
}

OEUserNotificationView.defaultProps = {
    className:                  '',
    notificationStdDuration:    3000,
    maxNotifications:           3,
    animate:                    true,
    animationDuration:          333
};

OEUserNotificationView.propTypes = {
    className:                  PropTypes.string,
    notificationStdDuration:    PropTypes.number,
    maxNotifications:           PropTypes.number,
    animate:                    PropTypes.bool,
    animationDuration:          PropTypes.number
};